import React from "react";
import StaffListPage from "./StaffListPage";

const HappySchoolStaffAll = () => (
  <StaffListPage title="Nhân sự toàn trường" departmentFilter={null} lockDepartment={false} />
);

export default HappySchoolStaffAll;
